import React from 'react';
import yellow from '@material-ui/core/colors/yellow';
import { getOrderNumberParts } from './OrderNumberPrintService';

interface Props {
    orderNumber: string;
}

export const OrderNumberPrint: React.FC<Props> = ({ orderNumber }) => {
    const parts = getOrderNumberParts(orderNumber);

    return (
        <span>
            {parts.map((part, index) =>
                part.highlight ? (
                    <span
                        key={index}
                        className="print-background"
                        style={{
                            backgroundColor: yellow[200]
                        }}
                    >
                        {part.text}
                    </span>
                ) : (
                    <span
                        key={index}
                        style={{ marginLeft: '10px', marginRight: '10px' }}
                    >
                        {part.text}
                    </span>
                )
            )}
        </span>
    );
};
